import React from 'react'
import { UnassignRequirementFlowProvider } from './context/UnassignRequirementFlowProvider'
import { UnassignRequirementFlowMain } from './components/UnassignRequirementFlowMain'

export const UnassignRequirementFlow = () => {
  return (
    <UnassignRequirementFlowProvider>
      <UnassignRequirementFlowMain />
    </UnassignRequirementFlowProvider>
  )
}
